import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { plainToClass } from 'class-transformer';
import { Rule } from 'app/admin/rules/rule.model';
import { AddRuleComponent } from 'app/admin/rules/addrule/add-rule.component';
import { RuleManagementService } from 'app/admin/rules/rule-management.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

@Component({
    selector: 'rule-list',
    templateUrl: './rule-list.component.html',
    styleUrls: ['./rule-list.component.css']
})

/**
 * Component for display the rules list.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class RuleListComponent implements OnInit {
    rule: Rule[];
    dialogRef: MdDialogRef<any>;
    selectedRule: Rule;
    isLoading = true;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private ruleManagementService: RuleManagementService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
    ) { }

    ngOnInit() {
        this.getRuleList();
    }

    getRuleList() {
        this.ruleManagementService.getRule()
            .subscribe(response => {
                this.rule = response;
                this.isLoading = false;
            }
            );
    }

    openAddRuleDialog(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRuleComponent, config);
        this.dialogRef.componentInstance.selectedRule = this.selectedRule;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            this.selectedRule = null;
            if (result) {
                setTimeout(() => { this.getRuleList() }, 500)
            }
        });
    }

    editRule(value: Rule): void {
        this.selectedRule = value
        this.openAddRuleDialog('Edit');
    }

    deleteRule(value: Rule): void {
        if (confirm(MessageService.DELETE_RULE_ALERT)) {
            this.ruleManagementService.deleteRule(value.id)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.rule.splice(this.rule.indexOf(value), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_RULE_SUCCESS, MessageService.DELETE_RULE_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_RULE_SUCCESS,
                        MessageService.DELETE_RULE_FAILURE);
                });
        }
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/rules/rulelist/rule-list.component.ts